export default "__VITE_ASSET__DuYeyA1Y__"